import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

export const WishlistButton = ({ productId, className = "", size = "w-4 h-4" }) => {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const on = !!user && (user.wishlist_ids || []).includes(productId);

  const toggle = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!user) { toast("Sign in to save items to your wishlist"); return nav("/login"); }
    try {
      const { data } = await api.post(`/wishlist/${productId}`);
      setUser({ ...user, wishlist_ids: data.wishlist_ids });
      toast.success(data.wishlisted ? "Saved to wishlist" : "Removed from wishlist");
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <button data-testid={`wishlist-toggle-${productId}`} onClick={toggle} aria-label={on ? "Remove from wishlist" : "Add to wishlist"} aria-pressed={on}
      className={`grid place-items-center transition-colors ${on ? "text-[#FF3B30]" : "text-white hover:text-[#FF3B30]"} ${className}`}>
      <Heart className={`${size} ${on ? "fill-[#FF3B30]" : ""}`} />
    </button>
  );
};
